import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`alert alert-${ _ctx.type }`),
    role: "alert",
    style: {"width":"60%"}
  }, _toDisplayString(_ctx.msg), 3))
}